<h2 class="td-wb-vh"
    translate="tdWb.menu.TOOLBAR_HEADER">
</h2>
<ul class="td-wb-menu-toolbar"
    role="toolbar"
    [class.td-wb-menu-toolbar--active]="toolbarLabelsVisible"
    [class.td-wb-menu-toolbar--search-bar]="hasSearchBar()"
    (mouseenter)="toolbarLabelsVisible = true"
    (mouseleave)="toolbarLabelsVisible = false">
  @for (utility of getUtilityToolbar(); track utility) {
    <li class="td-wb-menu-toolbar__item"
        role="presentation"
        (click)="onMenuClick(utility)">
      <a role="button"
         class="td-wb-menu-toolbar__button"
         [href]="utility.href"
         [attr.target]="utility.target">
        <span class="td-wb-menu-toolbar__icon-container">
          <td-wb-icon class="td-wb-menu-toolbar__icon"
                      [iconId]="removeIconPrefix(utility.icon.cssClass)"
                      size="35"/>
        </span>
        <div class="td-wb-menu-toolbar__label"
             [innerText]="utility.text"></div>
      </a>
    </li>
  }
</ul>

